import {
  jb_thumbnail_css_default
} from "./chunk.C5CXBETN.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  debounce
} from "./chunk.NKAUZW5M.js";
import {
  D,
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  e,
  n,
  r as r2
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-thumbnail/jb-thumbnail.ts
var JbThumbnail = class extends r {
  constructor() {
    super(...arguments);
    this._BREAKPOINT = 520;
    this._observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio > 0) {
          entry.target.play();
        } else {
          entry.target.pause();
        }
      });
    });
  }
  connectedCallback() {
    super.connectedCallback();
    this._largeTag = this.offsetWidth > this._BREAKPOINT;
    window.addEventListener("resize", debounce(this._windowResized.bind(this), 500));
  }
  firstUpdated() {
    if (!this._video) return;
    this._observer.observe(this._video);
    this._video.muted = true;
  }
  _windowResized() {
    this._largeTag = this.offsetWidth > this._BREAKPOINT;
  }
  render() {
    return ke`
      <div class="${this.aspect}">
        ${this.videoSrc ? ke`<video
              src="${this.videoSrc}"
              loop
              muted
            ></video>` : ke`<jb-picture
              .alt=${this.backgroundPicture.alt}
              .fit=${"cover"}
              .imgData=${this.backgroundPicture.imgData}
              .lazy=${this.backgroundPicture.lazy}
            ></jb-picture>`}
        ${this.type === "audio" ? ke`<jb-tag
              .type=${"audio"}
              .isLarge=${this._largeTag}
              class="${this.isLoading ? "loading" : D}"
            ></jb-tag>` : D}
        ${this.type === "video" ? ke`<jb-tag
              .type=${"play"}
              .isLarge=${this._largeTag}
              class="${this.isLoading ? "loading" : D}"
            ></jb-tag>` : D}
      </div>
    `;
  }
};
JbThumbnail.styles = [reset_css_default, jb_thumbnail_css_default];
__decorateClass([
  n()
], JbThumbnail.prototype, "aspect", 2);
__decorateClass([
  n({ type: Object })
], JbThumbnail.prototype, "backgroundPicture", 2);
__decorateClass([
  n({ type: Boolean })
], JbThumbnail.prototype, "isLoading", 2);
__decorateClass([
  n()
], JbThumbnail.prototype, "type", 2);
__decorateClass([
  n()
], JbThumbnail.prototype, "videoSrc", 2);
__decorateClass([
  r2()
], JbThumbnail.prototype, "_largeTag", 2);
__decorateClass([
  e("video")
], JbThumbnail.prototype, "_video", 2);
JbThumbnail = __decorateClass([
  customElement("jb-thumbnail")
], JbThumbnail);

export {
  JbThumbnail
};
